export default "__VITE_ASSET__DHhS$_WV__"